import prepareFriendlyUri from '@utils/prepareFriendlyUri';
const getCrosslinkProductUrl = (productName: string, productId: number | string): string => {
  const friendlyUriProductName = prepareFriendlyUri(productName);
  const localePrefix = typeof window !== 'undefined' ? (() => {
    const {
      pathname
    } = window.location;
    const firstSegment = pathname.split('/')[1];
    return firstSegment === 'global' || firstSegment.match(/^[a-z]{2}(-[A-Z]{2})?$/) ? firstSegment : '';
  })() : '';
  return `${localePrefix ? `/${localePrefix}` : ''}/product/${friendlyUriProductName}-${productId}`;
};
export default getCrosslinkProductUrl;